var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',_vm._b({},'el-image',_vm.$attrs,false),[(_vm.isPlaceholder)?_c('div',{staticClass:"image-slot",attrs:{"slot":"placeholder"},slot:"placeholder"},[_c('img',{staticClass:"placeholder",attrs:{"src":_vm.$t('placeholder_img')=='placeholder_img'?require('@/assets/images/anwen.png'):_vm.$t('placeholder_img')}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }